const calculateTotalsForUseOrLostExpense = (data, expenses) => {
  let prevTotal = 0
  let prevCobTotal = 0
  let currTotal = 0
  let currCobTotal = 0
  const isValid = []

  if (data.pastYearPeriod) {
    const pastList = expenses.filter(expense => expense.benefitPeriodId === data.pastYearPeriod.benefitPeriodId)

    prevTotal = pastList.reduce((total, expense) => {
      return total + Number(expense.UnpaidAmount)
    }, 0)

    prevCobTotal = pastList.reduce((total, expense) => {
      return total + Number(expense.CoordinationOfBenefitsAmount)
    }, 0)
    for (var i in pastList) {
      if (pastList[i].isValid) {
        isValid.push(pastList[i].isValid)
      }
    }
  }

  if (data.currentYearPeriod) {
    const currList = expenses.filter(expense => expense.benefitPeriodId === data.currentYearPeriod.benefitPeriodId)

    currTotal = currList.reduce((total, expense) => {
      return total + Number(expense.UnpaidAmount)
    }, 0)

    currCobTotal = currList.reduce((total, expense) => {
      return total + Number(expense.CoordinationOfBenefitsAmount)
    }, 0)
    for (var e in currList) {
      if (currList[e].isValid) {
        isValid.push(currList[e].isValid)
      }
    }
  }

  const prevPeriodTotal = data.pastYearPeriod ? Math.min((prevTotal - prevCobTotal), data.pastYearPeriod.benefitPeriodFunds).toFixed(2) : 0
  const currPeriodTotal = data.currentYearPeriod ? Math.min((currTotal - currCobTotal), data.currentYearPeriod.benefitPeriodFunds).toFixed(2) : 0

  return {
    prevTotal,
    prevCobTotal,
    prevPeriodTotal,
    currTotal,
    currCobTotal,
    currPeriodTotal,
    isValid
  }
}

const calcualteTotalsForCarryForwardExpense = (data, expenses) => {
  let balance = 0.00
  const prevPeriodFunds = data.pastYearPeriod ? Number(data.pastYearPeriod.benefitPeriodFunds) : 0
  const currPeriodFunds = data.currentYearPeriod ? Number(data.currentYearPeriod.benefitPeriodFunds) : 0
  const bothPeriodsTotalFund = prevPeriodFunds + currPeriodFunds

  const bothClaimsTotal = expenses.reduce((total, expense) => {
    return total + Number(expense.UnpaidAmount)
  }, 0)

  const prevList = expenses.filter(expense => expense.benefitPeriodId === (data.pastYearPeriod && data.pastYearPeriod.benefitPeriodId))
  let prevTotal = prevList.reduce((total, expense) => {
    return total + Number(expense.UnpaidAmount)
  }, 0)

  const currList = expenses.filter(expense => expense.benefitPeriodId === (data.currentYearPeriod && data.currentYearPeriod.benefitPeriodId))
  let currTotal = currList.reduce((total, expense) => {
    return total + Number(expense.UnpaidAmount)
  }, 0)

  let prevCob = prevList.reduce((total, expense) => {
    return total + Number(expense.CoordinationOfBenefitsAmount)
  }, 0)

  let currCob = currList.reduce((total, expense) => {
    return total + Number(expense.CoordinationOfBenefitsAmount)
  }, 0)

  // passing an array of valid expenses for cob only
  const isValid = []
  for (var i in prevList) {
    if (prevList[i].isValid) {
      isValid.push(prevList[i].isValid)
    }
  }
  for (var e in currList) {
    if (currList[e].isValid) {
      isValid.push(currList[e].isValid)
    }
  }

  if (prevTotal > prevPeriodFunds) {
    balance = Number(prevTotal - prevPeriodFunds)
    prevTotal = prevPeriodFunds
    currTotal = Number(currTotal) + Number(balance)
  }

  return {
    balance,
    prevTotal,
    prevPeriodFunds,
    currTotal,
    currPeriodFunds,
    bothClaimsTotal,
    bothPeriodsTotalFund,
    prevCob,
    currCob,
    isValid
  }
}

const calcualteTotalsForCarryForwardBalance = (data, expenses) => {
  const prevPeriodFunds = data.pastYearPeriod ? Number(data.pastYearPeriod.benefitPeriodFunds) : 0
  const currPeriodFunds = data.currentYearPeriod ? Number(data.currentYearPeriod.benefitPeriodFunds) : 0

  const prevExpenses = expenses.filter(expense => expense.benefitPeriodId === (data.pastYearPeriod && data.pastYearPeriod.benefitPeriodId))
  const currExpenses = expenses.filter(expense => expense.benefitPeriodId === (data.currentYearPeriod && data.currentYearPeriod.benefitPeriodId))

  const validPrevExpenses = prevExpenses.filter(expense => expense.isValid)
  const validCurrExpenses = currExpenses.filter(expense => expense.isValid)

  const prevExpensesTotal = validPrevExpenses.reduce((total, expense) => {
    return total + Number(expense.UnpaidAmount)
  }, 0)

  const prevExpensesCob = validPrevExpenses.reduce((total, expense) => {
    return total + Number(expense.CoordinationOfBenefitsAmount)
  }, 0)

  const prevAdjustedTotal = Math.max(prevExpensesTotal - prevExpensesCob, 0)

  const currExpensesTotal = validCurrExpenses.reduce((total, expense) => {
    return total + Number(expense.UnpaidAmount)
  }, 0)

  const currExpensesCob = validCurrExpenses.reduce((total, expense) => {
    return total + Number(expense.CoordinationOfBenefitsAmount)
  }, 0)

  const currAdjustedTotal = Math.max(currExpensesTotal - currExpensesCob, 0)

  let prevDisplayTotal = Math.min(prevAdjustedTotal, prevPeriodFunds)
  let currDisplayTotal = Math.min(currAdjustedTotal, currPeriodFunds)

  if (prevAdjustedTotal < prevPeriodFunds) {
    const remainingPrevFunds = prevPeriodFunds - prevAdjustedTotal
    prevDisplayTotal = Math.min(prevAdjustedTotal + currAdjustedTotal, prevPeriodFunds)
    currDisplayTotal = Math.max(Math.min(currAdjustedTotal - remainingPrevFunds, currPeriodFunds), 0)
  }

  const validPrevCount = validPrevExpenses.length
  const validCurrCount = validCurrExpenses.length
  const validTotalCount = validPrevCount + validCurrCount

  const prevPeriodPaidPartially = prevAdjustedTotal > prevPeriodFunds
  const prevPeriodConsumed = prevDisplayTotal >= prevPeriodFunds

  return {
    prevPeriodFunds,
    currPeriodFunds,
    prevExpensesTotal,
    prevExpensesCob,
    prevAdjustedTotal,
    prevDisplayTotal,
    prevPeriodPaidPartially,
    prevPeriodConsumed,
    currExpensesTotal,
    currExpensesCob,
    currAdjustedTotal,
    currDisplayTotal,
    validPrevCount,
    validCurrCount,
    validTotalCount
  }
}

export {
  calculateTotalsForUseOrLostExpense,
  calcualteTotalsForCarryForwardExpense,
  calcualteTotalsForCarryForwardBalance
}



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/HCSAExpenses/functions.js